import { useTranslation } from 'react-i18next';
import { useServerLocales } from '@/lib/i18n/useServerLocales';

/**
 * Non-blocking notice that `GET /admin/capabilities` failed. The console keeps working on the
 * bilingual fallback; the banner only explains why, so a missing locale never goes unnoticed.
 */
export function CapabilitiesBanner() {
  const { t } = useTranslation();
  const { failed } = useServerLocales();
  if (!failed) return null;
  return (
    <div
      role="status"
      data-testid="capabilities-banner"
      className="mb-md rounded-md border-[0.5px] border-signal-amber bg-signal-amber-fill px-md py-sm text-small text-signal-amber-ink"
    >
      <span className="font-medium">{t('capabilities.failedTitle')}</span>{' '}
      {t('capabilities.failedBody')}
    </div>
  );
}
